import type { EvalFailureModeTag } from "../types";
import { EvalFailureModeTagValues } from "../types";

const FAILURE_MODE_LABELS: Record<EvalFailureModeTag, string> = {
  wrong_doc_retrieved: "Wrong doc retrieved",
  insufficient_recall: "Insufficient recall",
  wrong_jurisdiction: "Wrong jurisdiction",
  hallucinated_citation: "Hallucinated citation",
  missing_clarification: "Missing clarification",
  incorrect_answer: "Incorrect answer",
  ambiguous_question: "Ambiguous question",
  other: "Other",
};

export const FAILURE_MODE_OPTIONS = Object.values(EvalFailureModeTagValues).map(
  (value) => ({
    value,
    label: FAILURE_MODE_LABELS[value],
  }),
);

export function formatFailureModeTag(tag: EvalFailureModeTag): string {
  return FAILURE_MODE_LABELS[tag] ?? tag;
}
